import React, { useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import { Skeleton } from "primereact/skeleton";
import MeaPage from "../../components/MeaPage";

export function TeacherHome() {
  const { school } = useLoaderData();
  const navigate = useNavigate();
  const [loadingDestination, setLoadingDestination] = useState(null);

  const goTo = (path) => {
    setLoadingDestination(path);
    navigate(path);
  };

  if (loadingDestination) {
    return (
      <MeaPage
        showBackButton={false}
        header={
          <div>
            <div
              style={{
                height: "180px",
                background:
                  'url("/images/school-empty-cover.jpeg") no-repeat',
                backgroundSize: "cover",
              }}
            ></div>
            <div className="px-4 py-0 md:px-6 lg:px-8 ">
              <div
                className="flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between relative"
                style={{
                  marginTop: "-2rem",
                  top: "-50px",
                  marginBottom: "-70px",
                }}
              >
                <div>
                  <div
                    style={{
                      width: "140px",
                      height: "140px",
                      borderRadius: "10px",
                    }}
                    className="mb-3 surface-card shadow-2 flex align-items-center justify-content-center"
                  >
                    <Skeleton width="90%" height="90%" borderRadius="10px" />
                  </div>
                  <Skeleton width="220px" height="2rem" className="mb-2" />
                  <Skeleton width="180px" height="1.5rem" />
                </div>
              </div>
            </div>
          </div>
        }
      >
        <div className="grid grid-nogutter pt-4">
          {[1, 2, 3].map((index) => (
            <div key={index} className="col-12 md:col-6 xl:col-4 p-3">
              <div className="surface-card shadow-1 border-round p-4">
                <div className="flex align-items-center gap-3">
                  <Skeleton width="70px" height="70px" borderRadius="12px" />
                  <div className="flex-1">
                    <Skeleton width="60%" height="1.4rem" className="mb-2" />
                    <Skeleton width="100%" height="1rem" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </MeaPage>
    );
  }

  return (
    <>
      <MeaPage
        showBackButton={false}
        header={
          <div>
            <div
              style={{
                height: "180px",
                background:
                  'url("/images/school-empty-cover.jpeg") no-repeat',
                backgroundSize: "cover",
              }}
            ></div>
            <div className="px-4 py-0 md:px-6 lg:px-8 ">
              <div
                className="flex flex-column lg:flex-row lg:align-items-center lg:justify-content-between relative"
                style={{
                  marginTop: "-2rem",
                  top: "-50px",
                  marginBottom: "-70px",
                }}
              >
                <div>
                  <div
                    style={{
                      width: "140px",
                      height: "140px",
                      borderRadius: "10px",
                    }}
                    className="mb-3 surface-card shadow-2 flex align-items-center justify-content-center"
                  >
                    <img
                      src={school?.avatar
                        ? school?.avatar + "?" + school?.updated_at
                        : "/images/school-empty-logo.svg"}
                      width="90%"
                      alt="Logo de l'école"
                    />
                  </div>
                  <div className="text-900 text-3xl font-medium mb-1">
                    {school?.name}
                  </div>
                  <div className="text-600 font-medium mb-3">
                    <span className="bg-teal-50 text-teal-700 px-3 py-1 border-round text-sm font-semibold">
                      Espace Enseignant(e)s
                    </span>
                  </div>
                </div>
                <div className="mt-3 lg:mt-0"></div>
              </div>
            </div>
          </div>
        }
      >
        <div className="grid grid-nogutter pt-4">
          <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => goTo("/school/" + school?.id + "/teacher/sessions")}
            >
              <div className="flex">
                <img
                  src="/images/icons/teachers.png"
                  style={{ width: "70px", height: "70px" }}
                  className="mr-3"
                  alt="Mes séances de cours"
                />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">
                    Mes séances de cours
                  </span>
                  <span className="text-600 font-medium mb-2">
                    Consulter vos séances de cours par mois et suivre les séances
                    effectivement réalisées.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => goTo("/school/" + school?.id + "/teacher/classes")}
            >
              <div className="flex">
                <img src="/images/icons/trainings.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="Mes classes" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Mes classes</span>
                  <span className="text-600 font-medium mb-2">Consulter vos classes, vos créneaux, les salles assignées et la liste de vos élèves.</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => goTo("/school/" + school?.id + "/teacher/avis-passage")}
            >
              <div className="flex">
                <img src="/images/icons/moving.png" style={{ width: '70px', height: '70px' }} className="mr-3" alt="Avis de passage" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Avis de passage</span>
                  <span className="text-600 font-medium mb-2">Saisir et consulter les décisions d'orientation et de passage de vos élèves pour la formation en cours.</span>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 md:col-6 xl:col-4 p-3">
            <div
              className="surface-card shadow-1 border-round p-4 cursor-pointer hover:shadow-3 h-full"
              onClick={() => goTo("/school/" + school?.id + "/teacher/agenda")}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  goTo("/school/" + school?.id + "/teacher/agenda");
                }
              }}
              role="button"
              tabIndex={0}
            >
              <div className="flex">
                <img src="/images/icons/checklist.png" style={{ width: "70px", height: "70px" }} className="mr-3" alt="Agenda" />
                <div className="flex flex-column align-items-start">
                  <span className="text-lg text-900 font-medium mb-1">Agenda</span>
                  <span className="text-600 font-medium mb-2">
                    Consulter les événements de la formation en cours.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </MeaPage>
    </>
  );
}
